import type { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/carClub',
    name: 'carClubDetails',
    meta: {
      title: '长城汽车', //车友会详情分享后的页面
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/carClub/details/index.vue'),
  },
  {
    path: '/activity',
    name: 'activityDetails',
    meta: {
      title: '', //活动详情
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/carClub/activity/index.vue'),
  },
  {
    path: '/activity/member',
    name: 'activityMember',
    meta: {
      title: '报名成员列表', //活动详情-成员列表
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/carClub/member/index.vue'),
  },
  {
    path: '/help/clubsDescription',
    name: 'clubsDescription',
    meta: {
      title: '俱乐部管理规范', //俱乐部管理规范
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/carClub/rule.vue'),
  },
]

export default routes
